
import { Component } from "vue-property-decorator";
// @ts-ignore
import ClickOutside from "vue-click-outside";

import Navigation from "./Navigation.vue";

@Component({
    directives: { ClickOutside },
})
export default class DesktopNavigation extends Navigation {}
